// extracted by mini-css-extract-plugin
export default {"call":"page_call__dbbhF","contain":"page_contain__UCACg","inputs":"page_inputs__LxueO","place":"page_place__qcXQb","message":"page_message__Sxrps"};